import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Games from './pages/Games';
import GameLoader from './components/GameLoader';
import { TokensProvider } from './components/TokenContext';

function App() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        fetch('https://api.fantasyworldtrpg.cz/casino-api/check-login.php', {
            method: 'GET',
            credentials: 'include'
        })
            .then(response => response.json())
            .then(data => {
                if (data.loggedIn) {
                    localStorage.setItem('fw_user', data.user);
                    setIsLoggedIn(true);
                } else {
                    window.location.href = 'https://fantasyworldtrpg.cz';
                }
            })
            .catch(() => window.location.href = 'https://fantasyworldtrpg.cz');
    }, []);

    return (
        <TokensProvider>
            <Router>
                <div className="container-fluid px-3 py-3">
                    <Routes>
                        <Route path="/" element={isLoggedIn ? <Games/> : <h1>Načítání...</h1>}/>
                        <Route path="/game/:name" element={<GameLoader/>}/>
                        <Route path="/games" element={<Games/>}/>
                    </Routes>
                </div>
            </Router>
        </TokensProvider>
    );
}

export default App;
